module.exports = __webpack_public_path__ + "img/hanau-logo-white.ef9b1eac.svg";